import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import MainHeader from "../../../components/header"

const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;




function Header({ onAdd }) {
  return (
    <Box
      position="static"
      sx={{
        backgroundColor: "#fff",
        fontWeight: 500,
        color: "#424242",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "flex-end",
      
      }}
    >
     
      <Button
        sx={{
          backgroundColor: primary,
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          px: { xs: 1, sm: 2.5 },
          py: { xs: 0.75, sm: 1.25 },
          minWidth: { xs: "80px", sm: "auto" },
          height: { xs: "32px", sm: "36px" },
          "& .MuiSvgIcon-root": {
            fontSize: { xs: "0.875rem", sm: "1.125rem" },
          },
          "& .MuiButton-startIcon": {
            marginRight: { xs: "4px", sm: "8px" },
          },
        }}
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onAdd}
      >
        Add User
      </Button>
    </Box>
  );
}

export default Header;
